import { http } from '@/core/helpers/http.helper';

export class PositionApplicationTypeService {
   async getPositionApplicationTypes() {
      const response = await http.get('/position-application-type', { ...cacheFirstConfig });
      return response.data;
   }

   async getPositionApplicationType() {
      throw Error('Method not implemented');
   }

   async postPositionApplicationType() {
      throw Error('Method not implemented');
   }

   async putPositionApplicationType() {
      throw Error('Method not implemented');
   }

   async deletePositionApplicationType() {
      throw Error('Method not implemented');
   }
}
